import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { get } from 'lodash'
import { compose } from 'recompose'
import { consentTypes } from 'redux/selectors/codeLists'
import { ModalCTA } from 'containers/misc'
import { ContactRemove } from 'containers/forms/contacts'
import { Checkbox, Input, InputDate, Select, Textarea } from 'components/fields'
import { Button, ButtonGroup } from 'components/misc'
import { form, permissions } from 'helpers/decorators'
import { apiCodeLists, apiConfiguration } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS, CONSENT_DELIVERY_TYPES, LEVELS, ORGANIZATION_MODES, PAYMENTS } from 'constants/enums'
import { awardModeScheme } from 'models/awards'
import { FormattedMessage } from 'react-intl'
import { REMOVE_CONTACT_TYPES } from '../../../../constants/enums'

const enhance = compose(
  apiCodeLists([
    'consentDeliveryTypes',
    'participantPaymentStates',
    'participantReasonsOfDeletionTypes'
  ]),
  permissions(),
  apiConfiguration(),
  form({
    form: 'taskParticipantEdit',
    initialProps: 'award',
    disableHook: true,
    initialPropsMapper: props => ({
      ...props,
      awardMode: {
        value: get(props, 'awardMode.value') === ORGANIZATION_MODES.offline.id
      }
    })
  })
)

class TaskParticipantEdit extends Component {
  static propTypes = {
    submitting: PropTypes.bool,
    pristine: PropTypes.bool,
    award: PropTypes.object,
    values: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    onEditSubmit: PropTypes.func,
    awardId: PropTypes.number.isRequired,
    onRegistrationDelete: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    person: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired,
    onGetOrganizationParentalConsentConfiguration: PropTypes.func.isRequired,
    onGetOrganizationRegistrationConfiguration: PropTypes.func.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired,
    permissions: PropTypes.object.isRequired
  }

  state = {
    deleteConfirmDialogOpen: false,
    showParentalEmailInfo: false
  }

  componentDidMount() {
    const { award } = this.props

    if (!award.organization) {
      return
    }

    this.props.onGetOrganizationParentalConsentConfiguration(
      award.organization.id
    )

    this.props.onGetOrganizationRegistrationConfiguration(
        award.organization.id
    )

    this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isBulkLogsEnabled.id, award.organization.id)

    switch(get(award, 'awardLevel.value')) {
      case LEVELS.BRONZE.value:
        this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isBulkLogsForBronzeEnabled.id, award.organization.id)
        break
      case LEVELS.SILVER.value:
        this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isBulkLogsForSilverEnabled.id, award.organization.id)
        break
      case LEVELS.GOLD.value:
        this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isBulkLogsForGoldEnabled.id, award.organization.id)
        break
      default: break
    }
  }

  handleGetOfflineData = () => {
    const { award, values } = this.props

    if (
      get(award, 'organization.organizationMode.value') ===
      ORGANIZATION_MODES.online.id
    ) {
      return {}
    }

    return {
      awardModeUpdateParam: 'AWARD_MODE,',
      ...awardModeScheme(get(values, 'awardMode.value'))
    }
  }

  handleDialogOpen = () => this.setState({ deleteConfirmDialogOpen: true })

  handleDialogClose = () => this.setState({ deleteConfirmDialogOpen: false })

  handleSubmit = data => {
    const { onEditSubmit, awardId, person, award } = this.props

    const { awardModeUpdateParam, awardMode } = this.handleGetOfflineData()

    const paymentStateCond = data.paymentState || get(data, 'participantRegistration.awardPayment.paymentNote')

    const awardUpdateDefinition = `${awardModeUpdateParam || ''}${paymentStateCond ? 'PAYMENT_STATE' : ''},${data.isPaymentConfirmed !== undefined ? 'PAYMENT_CONFIRMATION' : ''},${get(data, 'consentDeliveryType.value') ? 'CONSENT_DELIVERY_CONFIRMATION,CONSENT_DELIVERY_TYPE' : ''},${get(data, 'startDate') ? 'START_DATE' : ''},${data.isGivenSurveyConsent !== undefined ? 'SURVEY_CONSENT_CONFIRMATION' : ''}`

    const awardPayload = {
      paymentState: data.paymentState,
      isPaymentConfirmed: data.isPaymentConfirmed,
      startDate: data.startDate,
      paymentStateChangeNote: get(data, 'participantRegistration.awardPayment.paymentNote', undefined),
      consentDeliveryType: {
        value: get(data, 'consentDeliveryType.value')
      },
      isConsentDeliveryConfirmed: get(data, 'isConsentDeliveryConfirmed'),
      isGivenSurveyConsent: get(data, 'isGivenSurveyConsent'),
      isBulkLogEnabled: get(data, 'isBulkLogEnabled'),
      awardMode
    }

    const paymentPayload = {
      paymentDate: get(
        data,
        'participantRegistration.awardPayment.paymentDate'
      ),
      transactionId: get(
        data,
        'participantRegistration.awardPayment.transactionId'
      )
    }

    return onEditSubmit({
      awardPayload,
      awardUpdateDefinition,
      paymentPayload,
      awardId,
      isEmailConfirmed: get(data, 'participant.isEmailConfirmed'),
      personId: get(person, 'id'),
      initialData: award
    })
  }


  handleParentalConsentChange = selected => {
    const parentEmail = get(this.props.award, 'participantRegistration.parentEmail')

    if (selected.value === CONSENT_DELIVERY_TYPES.electronically.id && !parentEmail) {
      this.setState({ showParentalEmailInfo: true })
    } else {
      this.setState({ showParentalEmailInfo: false })
    }
  }

  getBulkLogsForAward = award => {
    const awardLevel = get(award, 'awardLevel.value')

    const orgId = get(award, 'organization.id')

    switch(awardLevel) {
      case LEVELS.BRONZE.value: return get(this.props.configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isBulkLogsForBronzeEnabled.id}].booleanValue`)
      case LEVELS.SILVER.value: return get(this.props.configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isBulkLogsForSilverEnabled.id}].booleanValue`)
      case LEVELS.GOLD.value: return get(this.props.configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isBulkLogsForGoldEnabled.id}].booleanValue`)
      default: return false
    }
  }

  render() {
    const {
      handleSubmit,
      person,
      codeLists,
      submitting,
      award,
      pristine,
      configuration,
      permissions
    } = this.props
    const isEditPaymentNoteEnabled = get(configuration, `valuesByOrganizationId[${get(award, 'organization.id')}][${CONFIGURATION_KEYS.offlineAu.id}].booleanValue`)

    const isPaymentNoteEditable = (permissions.isLeader && isEditPaymentNoteEnabled) || (!permissions.isLeader)

/*    const isPaymentNoteEditable = true*/

    const { deleteConfirmDialogOpen } = this.state

    let configKeys = []

    if (configuration.valuesByOrganizationId[award.organization.id]) {
      configKeys = [
        configuration.valuesByOrganizationId[award.organization.id][
          CONFIGURATION_KEYS
            .participantRegistrationParentalConsentElectronically.id
          ],
        configuration.valuesByOrganizationId[award.organization.id][
          CONFIGURATION_KEYS.participantRegistrationParentalConsentNotRequired
            .id
          ],
        configuration.valuesByOrganizationId[award.organization.id][
          CONFIGURATION_KEYS.participantRegistrationParentalConsentPaper.id
          ]
      ]
    }

    const consentDeliveryTypes = consentTypes(
      codeLists.consentDeliveryTypes.list,
      configKeys
    )

    const isModeCheckboxVisible =
      get(award, 'organization.organizationMode.value') !==
      ORGANIZATION_MODES.online.id

    const isChangingModeDisabled =
      get(award, 'organization.organizationMode.value') ===
      ORGANIZATION_MODES.offline.id

    const participantRegistrationId = get(award, 'participantRegistration.id')

    const disableTransactionIdEdit =
      get(
        award,
        'participantRegistration.awardPayment.originPaymentType.value'
      ) === PAYMENTS.ONLINE_MASTERCARD.id ||
      get(
        award,
        'participantRegistration.awardPayment.originPaymentType.value'
      ) === PAYMENTS.PAYPAL.id

    const awardPaymentState = get(award, 'paymentState.value')

    const isBulkLogsEnabled = get(configuration, `valuesByOrganizationId[${get(award, 'organization.id')}][${CONFIGURATION_KEYS.isBulkLogsEnabled.id}].booleanValue`)

    const isBulkLogsForAwardEnabled = this.getBulkLogsForAward(award)

    return (
      <div>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <h2 className="reset--margin-bottom">
            #
            {get(person, 'id')} - {get(person, 'firstName')}{' '}
            {get(person, 'lastName')}
          </h2>
          <h3 className="delta">{get(person, 'email')}</h3>
          <div className="row">
            <div className="col-xs-6">
              <InputDate
                label="Award Start date"
                intlKey="label.award_start_date"
                name="startDate"
                allowFuture={false}
              />
            </div>
            {isModeCheckboxVisible &&
            <div className="col-xs-6">
              <Checkbox
                name="awardMode.value"
                label="Participant is semi-offline"
                intlKey="label.participant_is_semi_offline"
                justify
                disabled={isChangingModeDisabled}
              />
            </div>}
          </div>
          <div className="row">
            <div className="col-xs-6">
              <Select
                label="Payment"
                intlKey="label.payment"
                name="paymentState.value"
                options={codeLists.participantPaymentStates.list}
              />
            </div>
            <div className="col-xs-6">
              <InputDate
                label="Payment date"
                intlKey="label.payment_date"
                name="participantRegistration.awardPayment.paymentDate"
                maxDay={moment().add(2, 'days')}
                anchorDirection="right"
              />
            </div>
          </div>
          {isPaymentNoteEditable &&
          <div className="row">
            <div className="col-xs-12">
              <Textarea
                label="Payment note"
                intlKey="label.override_payment_note"
                name="participantRegistration.awardPayment.paymentNote"
              />
            </div>
          </div>}
          <div className="row">
            <div className="col-xs-6">
              <Input
                label="Transaction ID"
                intlKey="label.transaction_id"
                name="participantRegistration.awardPayment.transactionId"
                disabled={disableTransactionIdEdit}
              />
            </div>
            <div className="col-xs-6">
              <Checkbox
                label="Confirmed"
                name="isPaymentConfirmed"
                intlKey="label.confirmed"
                justify
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <Select
                label="Parent's agreement"
                intlKey="label.parent_agreement"
                name="consentDeliveryType.value"
                options={consentDeliveryTypes}
                onSelectChange={this.handleParentalConsentChange}
              />
            </div>
            <div className="col-xs-6">
              <Checkbox
                label="Confirmed"
                intlKey="label.confirmed"
                name="isConsentDeliveryConfirmed"
                justify
              />
            </div>
          </div>
          {this.state.showParentalEmailInfo &&
          <div className="row">
            <div className="col-xs-12">
              <span className="control-label form-group">
                <FormattedMessage
                  id='parental_consent_email_info'
                  defaultMessage='Do not forget to check parent email and send the consent manually from award detail screen.' />
              </span>
            </div>
          </div>}
          <div className="row">
            <div className="col-xs-6">
              <Checkbox
                label="Email Confirmed"
                intlKey="label.email_confirmed"
                name="participant.isEmailConfirmed"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <Checkbox
                label="As an Award Participant I am happy to participate in the Foundation's Participant Satisfaction Surveys"
                intlKey="label.participant_survey"
                name="isGivenSurveyConsent"
              />
            </div>
            {isBulkLogsEnabled && isBulkLogsForAwardEnabled && <div className="col-xs-12">
               <Checkbox
                label="Allow adding logs in bulk"
                intlKey="label.allow_adding_logs_in_bulk"
                name="isBulkLogEnabled"
              />
            </div>}
          </div>
          <div className="row">
            <div className="col-xs-8">
              <ButtonGroup>
                <Button
                  type="button"
                  secondary
                  onClick={() => this.props.modal(null)}
                  intlKey="button.close"
                >
                  Close
                </Button>
                <Button
                  type="button"
                  secondary
                  negative
                  onClick={this.handleDialogOpen}
                  intlKey="button.delete_registration"
                >
                  Delete registration
                </Button>
              </ButtonGroup>
            </div>
            <div className="col-xs-4 text--right">
              <Button
                intlKey="button.save"
                isLoading={submitting}
                disabled={pristine}
              >
                Save
              </Button>
            </div>
          </div>
        </form>
        {deleteConfirmDialogOpen &&
        <ModalCTA>
          <ContactRemove
            id={get(person, 'id')}
            onClose={this.handleDialogClose}
            onDelete={(...params) =>
              this.props.onRegistrationDelete(...params, {
                participantRegistrationId
              })}
            reasonsList={codeLists.participantReasonsOfDeletionTypes.list}
            awardPaymentState={awardPaymentState}
            contactRemoveType={REMOVE_CONTACT_TYPES.PARTICIPANT_REGISTRATION.value}
          />
        </ModalCTA>}
      </div>
    )
  }
}

export default enhance(TaskParticipantEdit)
